import { Card, CardBody, Badge } from "reactstrap"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { formatReadableDate } from "utils/formatDate"

const detailRows = employee => [
  { label: "Employee ID", value: employee?.employee_id || "-" },
  { label: "Mobile", value: employee?.mobile || "-" },
  { label: "Email", value: employee?.email || "-" },
  { label: "Designation", value: employee?.designation?.title || "-" },
  { label: "Department", value: employee?.department?.name || "-" },
  {
    label: "Joining Date",
    value: employee?.joining_date ? formatReadableDate(employee.joining_date) : "-",
  },
]

const coverStyle = {
  background: "linear-gradient(135deg, #f7f9ff 0%, #eef3ff 52%, #e4ecff 100%)",
  borderBottom: "1px solid rgba(85, 110, 230, 0.12)",
}

const coverTitleStyle = {
  color: "#2f3b63",
}

const coverSubtitleStyle = {
  color: "#6c7aa5",
}

export default function EmployeeProfileCard({
  employee,
  statusMeta,
  loading = false,
  action = null,
}) {
  const profileImage = employee?.personal_attachments?.find(item => item?.url)?.url || null
  const rows = detailRows(employee)

  return (
    <Card className="border-0 shadow-sm overflow-hidden mb-4">
      <div className="px-4 pt-4 pb-5" style={coverStyle}>
        {loading ? (
          <ThemePlaceholder
            style={{
              width: 140,
              height: 28,
              borderRadius: 8,
              backgroundColor: "rgba(85,110,230,.12)",
            }}
          />
        ) : (
          <div className="d-flex justify-content-between align-items-start gap-3">
            <div>
              <h5 className="mb-1" style={coverTitleStyle}>Employee Profile</h5>
              <p className="mb-0" style={coverSubtitleStyle}>Core identity and assignment overview</p>
            </div>
            <div className="d-flex align-items-center gap-2">
              {action}
              <Badge className={`badge-soft-${statusMeta?.color || "secondary"} border-0`}>
                {statusMeta?.label || "-"}
              </Badge>
            </div>
          </div>
        )}
      </div>

      <CardBody className="p-4" style={{ marginTop: -42 }}>
        <div className="d-flex align-items-end gap-3 mb-4">
          <div
            className="rounded-4 overflow-hidden border border-3 border-white bg-white shadow-sm flex-shrink-0"
            style={{ width: 104, height: 104 }}
          >
            {loading ? (
              <ThemePlaceholder style={{ width: "100%", height: "100%", borderRadius: 0 }} />
            ) : profileImage ? (
              <img
                src={profileImage}
                alt={employee?.name || "Employee"}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <div
                className="w-100 h-100 d-flex align-items-center justify-content-center text-primary fw-bold"
                style={{ fontSize: 36, background: "#eef2ff" }}
              >
                {(employee?.name || "E").charAt(0).toUpperCase()}
              </div>
            )}
          </div>

          <div className="min-width-0 flex-grow-1">
            {loading ? (
              <>
                <ThemePlaceholder style={{ width: 220, height: 26, borderRadius: 8 }} />
                <ThemePlaceholder className="mt-2" style={{ width: 180, height: 18, borderRadius: 8 }} />
                <ThemePlaceholder className="mt-2" style={{ width: 140, height: 18, borderRadius: 8 }} />
              </>
            ) : (
              <>
                <h4 className="mb-1 text-truncate">{employee?.name || "Employee"}</h4>
                <p className="text-muted mb-1 text-truncate">
                  {employee?.designation?.title || "No designation assigned"}
                </p>
                <p className="text-muted mb-0 text-truncate">
                  {employee?.showroom?.name || "No showroom assigned"}
                </p>
              </>
            )}
          </div>
        </div>

        <div className="specs-list">
          {rows.map(item => (
            <div key={item.label} className="d-flex justify-content-between py-2 border-bottom gap-3">
              <span className="text-muted">{item.label}:</span>
              {loading ? (
                <ThemePlaceholder style={{ width: 140, height: 18, borderRadius: 4 }} />
              ) : (
                <span className="fw-medium text-end">{item.value}</span>
              )}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  )
}
